import React from 'react';
import Logo from './Logo';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
  logos: {
    marginTop: 10,
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    '& .gatsby-image-wrapper': {
      maxHeight: 80,
      '& img': {
        objectFit: 'contain!important'
      }
    },
  },
  logo: {
    boxSizing: 'border-box',
    padding: '15px 30px',
    width: 'calc(100%/6)',
    [theme.breakpoints.down('xs')]: {
      padding: '10px 15px',
      width: 'calc(100%/3)',
    }
  }
}));

const Logos = (props) => {

  const renderLogos = () => {
    return props.items.map((item, index) => {
      return (
        <div className={classes.logo} key={index}>
          <Logo id={item} />
        </div>
        
      );
    });
  }

  const classes = useStyles();
  return(
    <Grid container justifyContent='center'>
      <h2>{props.lang === 'en-CA' ? 'Clients that trust us' : 'Des clients qui nous font confiance'}</h2>
      <Grid className={classes.logos} container sm={12} item justifyContent='center' alignItems='center'>
        {renderLogos()}
      </Grid>
    </Grid>
  )
}

export default Logos;